import React from 'react';
import { SORT_CYCLE } from './laCarteModel';

interface Props {
  title: string;
  query: string;
  onQueryChange: (q: string) => void;
  sortIndex: number;
  onCycleSort: () => void;
  children?: React.ReactNode; // the color rail slots in under the search row
}

/** Frosted sticky chrome: collapsing compact title, search, sort cycle. */
const StickyBar: React.FC<Props> = ({ title, query, onQueryChange, sortIndex, onCycleSort, children }) => (
  <div className="lc-bar">
    <div className="lc-bar-inner">
      <div className="lc-bar-row">
        <span className="lc-compact-title lc-serif">{title}</span>
        <label className="lc-search">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" aria-hidden="true">
            <circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" />
          </svg>
          <input
            type="search"
            placeholder="Producer, wine, region"
            autoComplete="off"
            value={query}
            onChange={e => onQueryChange(e.target.value)}
            aria-label="Search wines"
          />
        </label>
        <button type="button" className="lc-sortbtn" onClick={onCycleSort} aria-label="Change sort">
          {SORT_CYCLE[sortIndex].label}
        </button>
      </div>
      {children}
    </div>
  </div>
);

export default StickyBar;
